export default {"src":"/_next/static/media/dust-mask.3804eba5.svg","height":147,"width":196,"blurWidth":0,"blurHeight":0};